module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boleta"
  }, [_c('div', {
    staticClass: "datos"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "up"
  }, [_c('div', {
    staticClass: "big"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.boleta.nombreMes) + " " + _vm._s(_vm.boleta.periodo))]), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.boleta.descripcionTipo))])]), _c('div', {
    staticClass: "big"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v(_vm._s(_vm.boleta.codigo))]), _c('span', [_vm._v(_vm._s(_vm.boleta.nombre))])])]), _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('span', [_vm._v("Dias trabajados:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.diasTrabajados))]), _c('br'), _c('span', [_vm._v("Dias vacaciones:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.diasVacaciones))]), _c('br'), _c('span', [_vm._v("Dias subsidio:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.diasSubsidio))])]), _c('div', [_c('span', [_vm._v("Horas trabajadas:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.horasTrabajadas))]), _c('br'), _c('span', [_vm._v("Horas extra:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.horasExtras))])])])]), _c('div', {
    staticClass: "down"
  }, [_c('table', {
    staticClass: "table table-mini is-bordered"
  }, [_vm._m(0), _c('tbody', [_vm._l((_vm.boleta.detalle), function(o) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(o.codigoRubro) + "  " + _vm._s(o.descripcionRubro))]), _c('td', {
      staticClass: "text-align-right"
    }, [(o.signo === '+') ? [_vm._v(_vm._s(o.monto.toFixed(2)))] : void 0], 2), _c('td', {
      staticClass: "text-align-right"
    }, [(o.signo === '-') ? [_vm._v(_vm._s(o.monto.toFixed(2)))] : void 0], 2), _c('td', {
      staticClass: "text-align-right"
    }, [(o.signo === '') ? [_vm._v(_vm._s(o.monto.toFixed(2)))] : void 0], 2)])
  }), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("Totales")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.totalIngresos.toFixed(2)))]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.totalEgresos.toFixed(2)))]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.totalAportes.toFixed(2)))])]), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("Neto a pagar")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }), _c('td', {
    staticClass: "font-bold text-align-right"
  }), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.montoAPagar.toFixed(2)))])]), _vm._m(1), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("C.C. Soles")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.cuentaCorrienteSoles.toFixed(2)))])]), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("C.C. Dólares")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.cuentaCorrienteDolares.toFixed(2)))])])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Rubro")]), _c('th', [_vm._v("Ingreso")]), _c('th', [_vm._v("Descuento")]), _c('th', [_vm._v("Aporte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td'), _c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43d50e80","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Boletas_Item_Transferidos.vue
// module id = 802
// module chunks = 0